import { render, staticRenderFns } from "./button.vue?vue&type=template&id=2a7b85af&scoped=true&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&id=2a7b85af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b85af",
  null
  
)

export default component.exports